import VenoBox from "venobox";

(function () {
  const links = document.querySelectorAll(
    ".is-style-social-card a[href*=youtu]"
  );

  for (const link of links) {
    link.dataset.autoplay = "true";
    link.dataset.vbtype = "video";
  }

  new VenoBox({
    selector: ".is-style-social-card a[href*=youtu]",
  });
})();
